import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { resetStoresAction } from '../actions/common';

type DangerType = Record<string, boolean | number>;

export type SidebarState = {
  dangers: DangerType;
  isSidebarShown: boolean;
};

const defaultState: SidebarState = {
  dangers: {},
  isSidebarShown: false,
};

type DanderActionPayload = {
  path: string;
  value?: number | boolean;
};

type SidebarReducers = {
  collapseSidebarAction: CaseReducer<SidebarState>;
  expandSidebarAction: CaseReducer<SidebarState>;
  removeSidebarDangerAction: CaseReducer<
    SidebarState,
    PayloadAction<DanderActionPayload>
  >;
  addSidebarDangerAction: CaseReducer<
    SidebarState,
    PayloadAction<DanderActionPayload>
  >;
};

const setDanger =
  (status: boolean) =>
  (state: SidebarState, { payload }): SidebarState => ({
    ...state,
    dangers: {
      ...state.dangers,
      [payload.path]: payload.value || status,
    },
  });

const sidebar = createSlice<SidebarState, SidebarReducers, 'sidebar', never>({
  name: 'sidebar',
  initialState: defaultState,
  reducers: {
    collapseSidebarAction: (state) => ({ ...state, isSidebarShown: false }),
    expandSidebarAction: (state) => ({ ...state, isSidebarShown: true }),
    removeSidebarDangerAction: setDanger(false),
    addSidebarDangerAction: setDanger(true),
  },
  extraReducers: (builder) =>
    builder.addCase(resetStoresAction, () => defaultState),
});

export const {
  collapseSidebarAction,
  expandSidebarAction,
  addSidebarDangerAction,
  removeSidebarDangerAction,
} = sidebar.actions;

export default sidebar.reducer;
